import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es845.js";
const m = {
  name: e.swedish,
  locale: o
};
export {
  m as date_sv
};
